import { render, staticRenderFns } from "./ConsultarDocumento.vue?vue&type=template&id=a46d199a"
import script from "./ConsultarDocumento.vue?vue&type=script&lang=js"
export * from "./ConsultarDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports